export const CLIENT_USER_ROLE = 'client-user';
export const RISK_MANAGER_ROLE = 'risk-manager';
export const LOCAL_CLIENT_VIEW_ROLE = 'local-client-view';
export const REPORTING_ROLE = 'reporting-viewer';

export type Role =
  | typeof CLIENT_USER_ROLE
  | typeof RISK_MANAGER_ROLE
  | typeof LOCAL_CLIENT_VIEW_ROLE
  | typeof REPORTING_ROLE;
